import React from 'react';
import {
  isPointContainedInBounds,
  isValidLocation,
  isPointShowMultipleTimes,
  getMapsWhereIsShowPoint,
  IS_SHOW_POINT
} from './../helpers/helper';
import { isNoFareMarker } from './../../InteractiveMapContainer/classes/MarkerData';
import EndRouteMarker from '../markers/EndRouteMarker';
type ReadingTypes = 'ONE_WAY' | 'ROUND_TRIP' | 'MULTI_CITY' | 'EACH_WAY';

const isEndRouteMarkerContainedInBounds = (
  lat: number,
  long: number,
  mapRef: any,
  useReducerBound: boolean,
  cyclicMapPaddingWidth: number
) => {
  return isPointContainedInBounds(lat, long, mapRef, useReducerBound, cyclicMapPaddingWidth);
};

export const renderEndRouteMarkerFn = ({
  oldEndRouteMarker,
  showEndMarker,
  isMobile,
  endRouteSettings,
  onClickCloseBtn,
  filterState,
  flightTypeMap,
  mapRef,
  cyclicMapPaddingWidth
}: any) => {
  if (oldEndRouteMarker && showEndMarker) {
    if (oldEndRouteMarker?.location) {
      const basicEndRouteMarkerProps = {
        isMobile: isMobile,
        showCloseButton: endRouteSettings.endRouteSettings ?? true,
        onClickCloseBtn: onClickCloseBtn,
        ...endRouteSettings
      };
      const basicMarkerProps = {
        marker: isNoFareMarker(oldEndRouteMarker)
          ? {
              ...oldEndRouteMarker,
              journeyType: filterState.flightType
                ? flightTypeMap[filterState.flightType as ReadingTypes]
                : flightTypeMap['ROUND_TRIP'],
              departureDate: filterState.dateRange?.start,
              returnDate: filterState.dateRange?.end
            }
          : oldEndRouteMarker
      };
      const useReducerBound = isPointShowMultipleTimes(
        oldEndRouteMarker?.location[0],
        oldEndRouteMarker?.location[1],
        mapRef
      );
      const oldEndRouteMarkerInBounds = [
        isEndRouteMarkerContainedInBounds(
          oldEndRouteMarker?.location[0],
          oldEndRouteMarker?.location[1],
          mapRef,
          useReducerBound,
          cyclicMapPaddingWidth
        ) ? (
          <EndRouteMarker {...basicMarkerProps} {...basicEndRouteMarkerProps} />
        ) : null,
        isValidLocation(oldEndRouteMarker?.location) &&
        isEndRouteMarkerContainedInBounds(
          oldEndRouteMarker?.location[0],
          oldEndRouteMarker?.location[1] - 360,
          mapRef,
          useReducerBound,
          cyclicMapPaddingWidth
        ) ? (
          <EndRouteMarker
            {...{
              marker: {
                ...basicMarkerProps.marker,
                location: [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] - 360]
              }
            }}
            {...basicEndRouteMarkerProps}
          />
        ) : null,
        isValidLocation(oldEndRouteMarker?.location) &&
        isEndRouteMarkerContainedInBounds(
          oldEndRouteMarker?.location[0],
          oldEndRouteMarker?.location[1] + 360,
          mapRef,
          useReducerBound,
          cyclicMapPaddingWidth
        ) ? (
          <EndRouteMarker
            {...{
              marker: {
                ...basicMarkerProps.marker,
                location: [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] + 360]
              }
            }}
            {...basicEndRouteMarkerProps}
          />
        ) : null
      ];
      for (let index = 0; index < oldEndRouteMarkerInBounds.length; index++) {
        const oldEndRoute = oldEndRouteMarkerInBounds[index];
        if (oldEndRoute) {
          return oldEndRoute;
        }
      }
      const mapsWhenIsShowPoint = getMapsWhereIsShowPoint(
        oldEndRouteMarker?.location[0],
        oldEndRouteMarker?.location[1],
        mapRef,
        0
      );
      if (mapsWhenIsShowPoint[0] === IS_SHOW_POINT) {
        return <EndRouteMarker {...basicMarkerProps} {...basicEndRouteMarkerProps} />;
      } else if (mapsWhenIsShowPoint[1] === IS_SHOW_POINT) {
        return (
          <EndRouteMarker
            {...{
              marker: {
                ...basicMarkerProps.marker,
                location: [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] - 360]
              }
            }}
            {...basicEndRouteMarkerProps}
          />
        );
      } else if (mapsWhenIsShowPoint[2] === IS_SHOW_POINT) {
        return (
          <EndRouteMarker
            {...{
              marker: {
                ...basicMarkerProps.marker,
                location: [oldEndRouteMarker.location[0], oldEndRouteMarker.location[1] + 360]
              }
            }}
            {...basicEndRouteMarkerProps}
          />
        );
      } else {
        return <EndRouteMarker {...basicMarkerProps} {...basicEndRouteMarkerProps} />;
      }
    }
  }
  return null;
};
